export default {
      id: "car-usage",
      viewBox: "0 0 39 30",
      url: __webpack_public_path__ + "img/icons.svg#car",
      toString: function () {
        return this.url;
      }
    }